export default function (fieldsSchema: any, templateFields: any) {
  if (!fieldsSchema.value && !templateFields.value) return;

  fieldsSchema.value.forEach((field: any) => {
    const fieldSettingsName = field.name;
    const intakeFields = field.intakeField;
    const customField = field.customField;
    const fieldsToIgnore = ['header', 'seperator', 'paragraph', 'file', 'photo'].includes(
      field.settings.type
    );

    if (!templateFields?.value?.fields) return;

    const templateFieldsName = templateFields.value.fields.map((field: any) => field.name);
    const noFieldsForTheTemplate = !templateFieldsName.includes(fieldSettingsName);
    const fieldsNotToShow =
      noFieldsForTheTemplate && !field.values && !fieldsToIgnore && !intakeFields && !customField;

    if (fieldsNotToShow) {
      field.settings.required = false;
      field.settings.show = false;
    }
  });
}
